import React from 'react';

import Input from '@components/uikit/Input/Input';
import Select from '@components/uikit/Select/Select';
import Switch from '@components/uikit/Switch/Switch';

import useTranslation from '@hooks/useTranslation';

import { USER_FIELDS } from '../../constants/schemaUser';
import style from './style.module.scss';

const StepPersonalInfo = ({ user, control, languageList }) => {
  const { t } = useTranslation();

  return (
    <div className={style.personalInfoStep}>
      <Input name={USER_FIELDS.NAME_FIRST} control={control} label={t('First Name')} required />
      <Input name={USER_FIELDS.NAME_LAST} control={control} label={t('Last Name')} required />
      <Input name={USER_FIELDS.EMAIL} control={control} label={t('Email Address')} required />
      <Input name={USER_FIELDS.USERNAME} control={control} label={t('User Name')} required />
      <Select
        name={USER_FIELDS.LANGUAGE}
        control={control}
        label={t('Language')}
        options={languageList}
        itemKeys={{ valueFieldKey: 'iso_code', labelFieldKey: 'name' }}
        required
      />
      <Input name={USER_FIELDS.COMPANY} control={control} label={t('Company')} required />
      <Input name={USER_FIELDS.PHONE} control={control} label={t('Contact Phone')} />
      <Input name={USER_FIELDS.JOB_TITLE} control={control} label={t('Job Title')} />
      {user?.id && <Switch name={USER_FIELDS.IS_ACTIVE} control={control} label={t('Active Profile')} />}
    </div>
  );
};

export default StepPersonalInfo;
